import PadraoModel from 'src/core/model/PadraoModel.js'

export default class SituacaoUsuarioModel extends PadraoModel {
  recurso = 'situacoes-usuarios';
  microServico = 'usuario';
  include = null;
  searchFixo = null;
  nome = 'Situações dos usuários';

  colunasGrid = [
    {
      name: 'acoes',
      label: 'Ações',
      field: 'acoes',
      style: 'width: 50px',
      align: 'left'
    },
    { name: 'id', label: 'ID', field: 'id' },
    { name: 'nome', label: 'Nome', field: 'nome' }
  ];

  form = {
    id: null,
    name: ''
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
